import script from "./MaintenanceRequestsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MaintenanceRequestsPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__